import React, { Component, PropTypes } from 'react';
import Column from './Column';
import { Styles } from 'material-ui';
import Note from 'components/Note';

const { Spacing } = Styles;

const styles = {
  noteContainer: {
    position: 'absolute',
    top: 0,
    right: -2,
    width: 1,
    bottom: 0
  },
  column: {
    transition: 'width 0.25s ease'
  }
};

export default class Row extends Component {
  static propTypes = {
    placement: PropTypes.array
  };

  static defaultProps = {};

  state = {
    mouseOver: false,
    noteEnabled: false
  };

  mouseEnter() {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    if (this._outTimer) {
      clearTimeout(this._outTimer);
    }
    this._timer = setTimeout(() => {
      this.state.mouseOver = true;
    }, 300);
  }

  mouseLeave() {
    this._outTimer = setTimeout(() => {
      this.state.mouseOver = false;
    }, 300);
  }

  enableNote() {
    this.state.noteEnabled = true;
  }

  disableNote() {
    this.state.noteEnabled = false;
  }

  render() {
    const columnCount = this.props.data.pageModules.length;
    const placement = this.props.placement || [6, 6];
    const defaultGridSize = Math.ceil(12 / columnCount);
    let columns = this.props.data.pageModules.map((module, index) => {
      const weight = placement[index] || 6;
      const gridSize =
        (columnCount === 2 && typeof weight !== 'undefined' && weight) ||
        defaultGridSize;
      const columnClass = 'col-md-' + gridSize;
      let noteComponent;
        let note = {
          text: (module.note && module.note.text) || '',
          color: (module.note && module.note.color) || 'coursio'
        };
        noteComponent = (
          <div style={{ paddingTop: 5 }}>
            <Note
              onEnable={::this.enableNote}
              onDisable={::this.disableNote}
              pageModuleId={module.id}
              {...note}
            />
          </div>
        );
      return (
        <div style={styles.column} className={columnClass}>
          {noteComponent}
          <div
            key={module.id}
            id={'pageModule-' + module.id}
          >
            <div style={{ position: 'relative' }}>
              <Column
                pageRowId={this.props.data.id}
                isQuiz={this.props.isQuiz}
                themeColor={this.props.themeColor}
                user={this.props.user}
                reader={this.props.reader}
                editor={this.props.editor}
                data={module}
                saving={module.saving}
                key={module.id}
                pageId={this.props.pageId}
                courseId={this.props.courseId}
                courseSlug={this.props.courseSlug}
                ownerName={this.props.ownerName}
              />
            </div>
          </div>
        </div>
      );
    });
    return (
      <div
        className="row"
        onMouseEnter={::this.mouseEnter}
        onMouseLeave={::this.mouseLeave}
      >
        {columns}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Page/Row.js